import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectEarlyAccessContactsFlowEnabled } from 'shared/selectors/earlyAccess/selectEarlyAccessContactsFlowEnabled';

import { ExportButtonNew } from '../../components/ExportButtonNew';
import { getExportLinks } from '../../selectors';

export function ExportButtonNewContainer() {
  const { docxUrl, pdfUrl } = useSelector(getExportLinks);
  const isEarlyAccessContactsFlowEnabled = useSelector(selectEarlyAccessContactsFlowEnabled);

  if (isEarlyAccessContactsFlowEnabled) {
    return null;
  }

  return <ExportButtonNew docxUrl={docxUrl} pdfUrl={pdfUrl} />;
}
